export function getdata() {
	var obj = {
		searchlist: [{
				prop: "nsrlx",
				label: '纳税人类型',
				type: "select",
				selectval: [{
					label: "明细登记",
					value: "3"
				}, ]
			},
			{
				prop: "tudmc",
				label: '房产名称',
				type: "input"
			},
		],
		searchdata: {
			nsrlx: '',
			tudmc: "",
		},
		headData: [{
				title: "纳税人名称",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "土地名称",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "土地性质",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "土地取得方式",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "土地用途",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "土地坐落地址",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "土地取得时间",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "占用土地面积",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "土地等级",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "月减免金额合计",
				prop: "companyCode",
				width: "200"
			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],

		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},

	}
	return obj
}
